export default "__VITE_ASSET__D5uDFu5B__"